import React, { Component } from 'react';
import legacyEventHub from '~/modules/legacyRuntime.js';

class CartItem extends Component{

  constructor(props) {
    super(props);

    this.playTrack = this.playTrack.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleAudioPlayerPlay = this.handleAudioPlayerPlay.bind(this);
    this.handleAudioPlayerStop = this.handleAudioPlayerStop.bind(this);
    this.unregisterEventHubListeners = this.unregisterEventHubListeners.bind(this);
    this.csrfToken = this.csrfToken.bind(this);

    this.eventHubListeners = [];

    this.state = {
      playing: false
    };
  }

  componentDidMount() {
    this.registerEventHubListener('audioPlayerPlay', this.handleAudioPlayerPlay);
    this.registerEventHubListener('audioPlayerStop', this.handleAudioPlayerStop);
    this.registerEventHubListener('audioPlayerEnded', this.handleAudioPlayerStop);
  }

  componentWillUnmount() {
    this.unregisterEventHubListeners();
  }

  registerEventHubListener(eventName, handler) {
    legacyEventHub.on(eventName, handler);
    this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  unregisterEventHubListeners() {
    if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
      this.eventHubListeners = [];
      return;
    }

    this.eventHubListeners.forEach((listener) => {
      legacyEventHub.off(listener.eventName, listener.handler);
    });
    this.eventHubListeners = [];
  }

  handleAudioPlayerPlay(data) {
    if (data[0].id === this.props.id) {
      this.setState({
        playing : true
      });
    }
  }

  handleAudioPlayerStop() {
    if (this.state.playing) {
      this.setState({
        playing : false
      });
    }
  }

  handleRemoveClick(e) {
    const usageLicenseTypeId = this.props.usageLicenseTypeId || (this.props.usageLicenseType && this.props.usageLicenseType.id) || this.props.usage_license_type_id;
    let updateUrl;

    e.preventDefault();
    if (typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }

    const params = new URLSearchParams();
    params.set('usage_license_type_id', usageLicenseTypeId);
    params.set('remove', 'true');

    this.normalizedProjectLicenseOptionKeys().forEach((optionKey) => {
      params.append('project_license_option_keys[]', optionKey);
    });

    if (this.props.customerProjectLicensePresetId) {
      params.set('customer_project_license_preset_id', this.props.customerProjectLicensePresetId);
    }

    if (this.props.customerEventLicensePresetId) {
      params.set('customer_event_license_preset_id', this.props.customerEventLicensePresetId);
    }

    if (this.props.exposure_pack_id) {
        params.set('exposure_pack_id', this.props.exposure_pack_id);
        updateUrl = `/cart?${params.toString()}`;
    } else if (this.props.sound_effect_id) {
        params.set('sound_effect_id', this.props.sound_effect_id);
        updateUrl = `/cart?${params.toString()}`;
    } else {
        params.set('track_id', this.props.id);
        updateUrl = `/cart?${params.toString()}`;
    }

    return fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': this.csrfToken()
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart remove failed with status ${response.status}`);
        }

        return response.json();
      })
      .then((data) => {
        legacyEventHub.trigger('updateCart', data);
      })
      .catch((error) => {
        // Keep failure handling minimal here; we only want to avoid a hard client crash.
        console.error(error);
      });
  }

  csrfToken() {
    if (typeof document === 'undefined') {
      return '';
    }

    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
  }

  normalizedProjectLicenseOptionKeys() {
    return Array(this.props.projectLicenseOptionKeys)
      .flatMap((value) => String(value || '').split(','))
      .map((value) => value.trim())
      .filter(Boolean);
  }

  hasUnconfiguredProjectLicense() {
    return this.props.projectLicenseFlow === 'v2' &&
      !this.props.customerProjectLicensePresetId &&
      this.normalizedProjectLicenseOptionKeys().length === 0;
  }

  playTrack(e) {
    e.preventDefault();
    if (this.props.sound_effect_id) {
      legacyEventHub.trigger('playSoundEffect', this.props.sound_effect_id);
    } else {
      legacyEventHub.trigger('playTrack', this.props.id, this.props);
    }

    legacyEventHub.trigger('updateTrackInfo', this.props);

    this.setState({
      playing: !this.state.playing
    });
  }

  render() {
    let price;
    let priceIsFree = false;
    let showStartingPrice = false;
    const usageLicenseType = this.props.usageLicenseType || {};
    const usageLicenseLabel = this.props.projectLicensePresetName || usageLicenseType.name;

    if (this.props.discount) {
      price = usageLicenseType.formatted_country_discount_gross_price;
    } else if (this.props.includedInSubscription) {
      price = this.props.locale === 'de' ? 'kostenlos' : 'free';
      priceIsFree = true;
    } else {
      price = usageLicenseType.formatted_country_gross_price;
    }

    showStartingPrice = !priceIsFree && price && (
      (this.props.eventTrackLicense && !this.props.eventTrackPriceFinal) ||
      this.hasUnconfiguredProjectLicense()
    );

    return (
      <div className="cart__item">
        <div className='cart__item-card'>
          <a href="#" onClick={this.playTrack} className='cart__item-main'>
            <span className='cart__item-artwork'>
              {this.props.track_image_markup ? (
                <span className='cart__item-image' dangerouslySetInnerHTML={{__html: this.props.track_image_markup}} />
              ) : null}
              <i className={this.state.playing ? 'fa fa-pause cart__item-artwork-icon' : 'fa fa-play cart__item-artwork-icon' } />
            </span>
            <span className='cart__item-title-info'>
              <span className='cart__item__title'>
                {this.props.title}
              </span>
              <span className='cart__item-usage-license-type-name'>
                {usageLicenseLabel}
              </span>
            </span>
          </a>
          <div className='cart__item-side'>
            <span className='cart__item-price'>
              {showStartingPrice ? <span className='cart__item-price-prefix'>{this.props.locale === 'de' ? 'ab' : 'from'}</span> : null}
              {price}
            </span>
            <button type='button' onClick={this.handleRemoveClick} className='cart__item-remove'>
              {this.props.locale === 'de' ? 'Entfernen' : 'Remove'}
            </button>
          </div>
        </div>
      </div>
    )
  }
};

export default CartItem;
